import React, { FC } from 'react';

import { EvButton, EvIcon, IEvButtonProps } from '@evinced-private/ui-common';

import './IconTextButton.scss';

interface IIconTextButtonProps extends Omit<IEvButtonProps, 'children' | 'title'> {
	icon: string;
	label: string;
}

export const IconTextButton: FC<IIconTextButtonProps> = ({
	icon,
	label,
	className,
	...buttonProps
}: IIconTextButtonProps) => {
	const combinedClassName = `icon-text-button ${className || ''}`.trim();

	return (
		<EvButton {...buttonProps} className={combinedClassName}>
			<EvIcon icon={icon} small className="icon-text-button__icon" />
			{label}
		</EvButton>
	);
};
